export const dynamicImageUrlTransPath = (path: string) => {
  const glob = import.meta.glob('/assets/pages/**/*', {
    eager: true,
    import: 'default',
  })
  const assetsUrl = glob[path]
  if (typeof assetsUrl === 'string') {
    return assetsUrl
  }
  return ''
}
